// extracted by mini-css-extract-plugin
module.exports = {"Hero":"hero-module--Hero--1uNV9","HeroText":"hero-module--HeroText--3oCaq"};